import React, { useState } from 'react';

export default function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <style>
        {`
        
.pq-section.pq-style-1.text-center {
  text-align: center;
  margin-bottom: 40px;
}

.pq-section-sub-title {
  font-size: 18px;
  color: #666;
  display: block;
  margin-bottom: 10px;
}

.pq-section-title {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}


.pq-accordion-block {
  width: 100%;
}

.pq-accordion-box {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.pq-accordion-box.active {
  border-color: #239857;
}

.pq-ad-title {
  padding: 15px;
  background-color: #f9f9f9;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ad-title-text {
  font-size: 16px;
  color: #333;
  margin: 0;
  flex: 1;
}

.pq-accordion-details {
  padding: 0 15px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
}

.pq-accordion-details.open {
  padding: 15px;
  max-height: 500px; 
}

.pq-detail-text {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
  margin: 0;
}

.fa {
  font-size: 14px;
  color: #239857;
  transition: transform 0.3s ease;
}

.fa-chevron-down {
  transform: rotate(0deg);
}

.fa-chevron-up {
  transform: rotate(180deg);
}
.pq-accordion-block .pq-accordion-box .pq-accordion-details {
  padding: 0 20px  !important;
  border: 1px solid var(--grey-color);
  border-top: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}
`}
      </style>
      <section className="faq">
        <div className="container py-4">
          <div className="row">
              
              <div className="col-md-7">
                  <div className="pq-section pq-style-1 text-center">
                    <h2 className="pq-section-title">Frequently Asked Questions (FAQ’s)</h2>
                  </div>
            
                  <div className="col-xl-12 mt-xl-0 ps-xl-3">
                    <div className="pq-accordion-block mt-4">
                      {[ 
                        { question: "What is Tonsillectomy Surgery?", answer: "Tonsillectomy is a surgical procedure to remove the tonsils — two small glands at the back of your throat. It’s often recommended when you have frequent throat infections or enlarged tonsils causing breathing issues." },
                        { question: "When is Tonsillectomy needed?", answer: "You may need a tonsillectomy if you suffer from repeated tonsillitis, difficulty swallowing, snoring, or sleep disturbances due to enlarged tonsils." },
                        { question: "Is Tonsillectomy a painful procedure?", answer: "Tonsillectomy is performed under anesthesia, so there’s no pain during the surgery. Discomfort or sore throat and pain after the procedure is normal and managed with medications." },
                        { question: "Why choose MedFirst ENT Centre for Tonsillectomy Surgery?", answer: "At MedFirst ENT Centre, Dr. (Major) Rajesh Bhardwaj offers advanced  Tonsillectomy procedure with personalized care and fast recovery — trusted by patients across Delhi and India." },
                      ].map((item, index) => (
                        <div className={`pq-accordion-box ${activeIndex === index ? 'active' : ''}`} key={index}>
                          <div className="pq-ad-title" onClick={() => toggleAccordion(index)}>
                            <h4 className="ad-title-text">
                              {item.question}
                              <i className={`fa ${activeIndex === index ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                            </h4>
                          </div>
                          <div className={`pq-accordion-details ${activeIndex === index ? 'open' : ''}`}>
                            <p className="pq-detail-text">{item.answer}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
              </div>
			  <div className="col-md-5 m-auto">
                  <div className="card shadow-lg">
                      <iframe width="100%" height="280px" src="https://www.youtube.com/embed/TQXaw8VN9ZA?si=NP6YBH33nFFlTagp" title="Tonsillectomy" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen ></iframe>
                  <div class="p-3"><h5 class="text-success mb-0">Tonsillectomy Surgery |टॉन्सिल का ऑपरेशन| Dr. Major Rajesh Bhardwaj </h5></div>
				  </div>
              </div>
          </div>
        </div>
      </section>
    </div>
  );
}
